import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { AxiosError } from 'axios';

export const logoutEmployee = async () => {
  const response = await CustomAxios.post(`logout`);
  const { data } = response;
  return data;
};

type useLogoutEmployeeProps = {
  onSuccessCallback: () => void;
};
export function useLogoutEmployee({ onSuccessCallback }: useLogoutEmployeeProps) {
  return useMutation({
    mutationFn: logoutEmployee,
    onSuccess: () => {
      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      console.log('useLogoutEmployee.ts ~ 25 err', err);
    }
  });
}
